<template>
  <div class="tree column">
    <div class="row column-s align-center head">
      <div class="title grid-12-s text-center-s">
        <i class="fa fa-file-text" /> &nbsp;{{ tree.title }}
      </div>
      <div class="new row align-center column-s grow-1 grid-12-s">
        <Button v-if="!tree.newItem" layout="blue-go" @click="tree.newItem = true" title="NOVO"><i class="fa fa-plus" />
          NOVO</Button>
        <Button v-if="tree.newItem" layout="red-go" @click="tree.newItem = false" title="FECHAR"><i
            class="fa fa-times" /> FECHAR</Button>
        <TreeLine :item="tree" :isNew="true" v-if="tree.newItem" />
      </div>
    </div>
    <div class="content">
      <div v-for="(item1, i) of tree.list" :key="'item1' + i" class="column tree-list">
        <div class="node-1 row align-center e" :class="item1.show ? 'active-1' : ''">
          <div class="grid-2 row" @click="toggle(i)" :title="show[i] ? 'RECOLHER' : 'EXPANDIR'">
            <div class="grid">
              {{ item1.nome }}
            </div>
            <strong>
              <i class="fa" :class="show[i] ? 'fa-chevron-up' : 'fa-chevron-down'"
                :title="show[i] ? 'RECOLHER' : 'EXPANDIR'"></i>
            </strong>
          </div>
          <div class="edit">
            <i class="edit-icon fa fa-pencil font-20" v-if="!item1.show" @click="edit(tree.list[i])" title="EDITAR" />
            <i class="fa fa-times" title="FECHAR" @click="close(tree.list[i])" v-if="item1.show" />
          </div>
          <div class="edit grow-1">
            <TreeLine :item="{ ...item1, ...tree }" v-if="item1.show" />
          </div>
        </div>
        <template v-if="show[i]">
          <Loader v-if="load" layout="small" />
          <div v-if="tree.title == 'especialidades'" v-for="(a, k) of areas[i]" :key="'area' + k" class="node-2"
            :class="a.show ? 'active-2' : ''" title="EDITAR">
            <div class="e row align-center">
              <div class="grid-2 row align-center" @click="ctoggle(i, k)"
                :title="cshow[i][k] ? 'RECOLHER' : 'EXPANDIR'">
                <div class="grid">{{ a.nome }}</div>
                <strong>
                  <i class="fa" :class="cshow[i][k] ? 'fa-chevron-up' : 'fa-chevron-down'"
                    :title="cshow[i][k] ? 'RECOLHER' : 'EXPANDIR'"></i>
                </strong>
              </div>
              <div class="line edit row grid-12 align-center">
                <div class="edit">
                  <i class="edit-icon fa fa-pencil" title="EDITAR" v-if="!a.show" @click="edit(areas[i][k])" />
                  <i class="fa fa-times" title="FECHAR" @click="close(areas[i][k])" v-if="a.show" />
                </div>
                <div class="desc" v-if="!a.show" @click="edit(areas[i][k])">{{ a.descricao }}</div>
                <TreeLine :item="{ ...a, ...tree, type: 'area' }" v-if="a.show" />
              </div>
            </div>

            <template v-if="cshow[i][k]">
              <Loader v-if="cload" layout="small" />
              <div v-for="(c, m) of a.competencias" :key="'competencias' + m" class="node-3 row align-center"
                :class="c.show ? 'active-2' : ''" title="EDITAR">
                <div class="grid-2 row" @click="edit(areas[i][k].competencias[m])">{{ c.nome }}</div>
                <div class="line edit row grid-12 align-center">
                  <div class="edit">
                    <i class="edit-icon2 fa fa-pencil" title="EDITAR" v-if="!c.show"
                      @click="edit(areas[i][k].competencias[m])" />
                    <i class="fa fa-times" title="FECHAR" @click="close(areas[i][k].competencias[m])" v-if="c.show" />
                  </div>
                  <div class="desc" v-if="!c.show" @click="edit(areas[i][k].competencias[m])">{{ c.descricao }}</div>
                  <TreeLine :item="{ ...c, ...tree, type: 'competencia' }" v-if="c.show" />
                </div>
              </div>
            </template>
          </div>

          <div v-if="tree.title != 'especialidades'" v-for="(item2, j) of tree.list[i][tree.title]" :key="'item2' + j"
            class="node-2 row align-center" :class="item2.show ? 'active-2' : ''" title="EDITAR">

            <div class="grid-2" @click="edit(tree.list[i][tree.title][j])" title="EDITAR">
              {{ tree.list[i][tree.title][j].nome }}
            </div>
            <div class="line edit row grid-12 align-center">
              <div class="edit">
                <i class="edit-icon fa fa-pencil" title="EDITAR" v-if="!item2.show"
                  @click="edit(tree.list[i][tree.title][j])" />
                <i class="fa fa-times" title="FECHAR" @click="close(tree.list[i][tree.title][j])" v-if="item2.show" />
              </div>
              <div class="desc" v-if="!item2.show" @click="edit(tree.list[i][tree.title][j])">
                {{ item2.descricao }}
              </div>
              <TreeLine :item="{ ...item2, ...tree }" v-if="item2.show" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import TreeLine from "@/components/TreeLine.vue";
import Loader from "@/components/Loader";

export default {
  name: "Tree",
  props: { tree: Object },
  components: {
    Button,
    TreeLine,
    Loader
  },
  data() {
    return {
      show: {}, cshow: {}, areas: {}, load: false, cload: false
    };
  },
  methods: {
    ...mapActions("admin", ["AREAS_LIST", "COMPETENCIAS_LIST"]),
    async ctoggle(i, k) {
      if (!this.cshow[i]) this.cshow[i] = {}
      this.cshow[i][k] = !this.cshow[i][k];
      this.$forceUpdate();
      if (this.cshow[i][k] && !this.areas[i][k].competencias) {
        this.cload = true
        let { data } = await this.COMPETENCIAS_LIST({ id_area: this.areas[i][k].id }).catch(() => this.cload = false)
        if (data) this.areas[i][k].competencias = data
        this.cload = false
      }
    },
    async toggle(index) {
      this.show[index] = !this.show[index];
      this.$forceUpdate();
      if (this.show[index] && this.tree.title == "especialidades" && !this.areas[index]) {
        this.load = true
        let { data } = await this.AREAS_LIST({ id_especialidade: this.tree.list[index].id }).catch(() => this.load = false)
        if (data) (this.areas[index] = data, this.cshow[index] = {})
        this.load = false
      }
    },
    edit(item) {
      item.show = true;
      this.$forceUpdate();
    },
    close(item) {
      item.show = false;
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.tree {
  background: #fff;
  border-radius: 23px;
  box-shadow: $shadow;
  margin-right: 15px;

  @media (max-width: $small) {
    margin-bottom: 25px;
  }

  .head {
    border-bottom: 2px inset $gray-9;
    margin-bottom: 12px;
    padding: 13px;
    background: $gray-4;
    opacity: 0.7;

    .title {
      font-size: 19px;
      color: $gray-8;
      letter-spacing: 1.4px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .new {
      .button {
        font-size: 12px;
      }

      .button-blue-go,
      .button-red-go {
        font-size: 10px;
        height: 32px;
      }

      .button-red-go {
        @media (max-width: $small) {
          margin-bottom: 20px;
        }

        @media (min-width: $small) {
          margin-right: 10px;
        }
      }

      @media (max-width: $small) {
        margin-top: 15px;
      }

      @media (min-width: $small) {
        margin-left: 10px;
      }
    }
  }

  .content {
    overflow: auto;
    max-height: 600px;
  }

  &-list {
    padding: 14px 16px;
    color: $gray-5;

    .node-1 {
      padding-left: 7px;
      padding-bottom: 7px;
      font-weight: bold;
      cursor: pointer;
    }

    .node-2,
    .node-3 {
      margin: 4px 25px;
      list-style: circle;
      cursor: pointer;
    }

    .node-1,
    .node-2,
    .node-3 {
      padding: 7px 15px;
      border-radius: 4px;

      .edit {
        font-size: 18px;
        margin-right: 10px;
        line-height: 16px;
      }

      .edit-icon,
      .edit-icon2 {
        margin-left: 5px;
        display: none;
      }

      .line {
        .desc {
          font-size: 13px;
        }
      }
    }

    .e:hover {
      color: $blue-5;

      .edit-icon {
        display: inline-block;
      }
    }

    .node-3:hover {
      color: $blue-5;

      .edit-icon2 {
        display: inline-block;
      }
    }

    .loader {
      margin: 25px 80px
    }

    .node-2 {

      &:nth-child(odd) {
        background: #eee;
      }

      padding-top: 14px;
    }

    .active-1 {
      background: #ddd;
    }

    .active-2 {
      background: #ccc;
    }

    .edit {
      margin-left: 5px;
    }
  }
}
</style>